import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button.tsx';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip.tsx';
import { generalMessages } from 'src/utils/messages.ts';

import type { ParkingPointsOfInterest } from 'src/features/parkingManagement/types/parking.ts';

//TODO: add permissions for edit/delete exit/entrance point

interface CellPointOfInterestActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    deleteCallback: (point: TData) => void;
}
function CellPointOfInterestActions({
    deleteCallback,
    row,
}: CellPointOfInterestActionsProps<ParkingPointsOfInterest, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="ml-auto flex max-w-24 gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={() => deleteCallback(row.original)} size="icon" variant="link">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>{`${formatMessage(generalMessages.delete)} ${row.original.name}`}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellPointOfInterestActions };
